import { render, staticRenderFns } from "./AppReviewInfoSection.vue?vue&type=template&id=811e8fa0&scoped=true"
import script from "./AppReviewInfoSection.vue?vue&type=script&lang=js"
export * from "./AppReviewInfoSection.vue?vue&type=script&lang=js"
import style0 from "./AppReviewInfoSection.vue?vue&type=style&index=0&id=811e8fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811e8fa0",
  null
  
)

export default component.exports